import { render } from "./TheResults.vue?vue&type=template&id=4f5e4d8a"
import script from "./TheResults.vue?vue&type=script&lang=js"
export * from "./TheResults.vue?vue&type=script&lang=js"

import "./TheResults.vue?vue&type=style&index=0&id=4f5e4d8a&lang=css"

import exportComponent from "D:\\CUFE24\\Cources\\Vue JS Net Ninja\\third-task-reaction-timer-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__